<template>
  <div>
    <div class="box" v-for="(item, index) in list" :key="index">
      <div class="title">
        <div class="methodTitle">
          <h3>{{ item.pkName }}</h3>
          <van-icon @click="$emit('delOrder', index)" name="close" />
        </div>
        <div class="methodSlidebt">
          <ul>
            <li> <h3>单价</h3> <p>{{ item.dj }}</p> </li>
            <li> <h3>数量</h3> <p>{{ item.sl }}</p> </li>
            <li> <h3>金额</h3> <p>{{ item.je }}</p> </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-show="list.length === 0" class="titless">
      暂无采购项
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  watch: {},
  computed: {},
  methods: {
  },
  beforeCreate () {},
  created () {},
  mounted () {}
}
</script>

<style scoped lang='less'>
  [class*=van-hairline]::after {
    border: none;
  }
  .box {
    width: 690px;
    height: 250px;
    background-color: #fff;
    margin: 0 auto 20px;
    box-shadow: 0 4px 10px 5px rgba(15,27,115,8%);
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px 40px 20px;
    .title {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .methodTitle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        h3 {
          font-size: 30px;
          color: #272729;
          line-height: 20px;
          font-weight: 400;
        }
        i {
          position: absolute;
          font-size: 40px;
          top: 12px;
          right: 12px;
          color: rgb(168, 168, 168);
        }
      }
      .methodSlidebt {
        ul {
          display: flex;
          justify-content: space-between;
          height: 100px;
          li {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            h3 {
              line-height: 18px;
              font-size: 30px;
              color: #9D9DA3;
            }
            p {
              line-height: 20px;
              font-size: 30px;
              color: #272729;
            }
          }
        }
      }
    }
    .btn {
      flex: 1;
      text-align: center;
      padding-left: 45px;
      .van-button {
        width: 100px;
      }
    }
  }
  .box:after {
    display: block;
    content: "";
    width: 32px;
    height: 32px;
    background: url(../assets/yans-1.png) no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .titless {
    font-size:25px;
    text-align: center;
    color: #969799;
  }
</style>
